import Wick from "./wick.js"
import MultipleWickOptions from "./multiple-wick-options.js"
import DoubleWicked from "./double-wicked.js"
import TripleWicked from "./triple-wicked.js"
import Wax from "./wax.js"
import WaxGroup from "./wax-group.js"

class WaxFactory {
  constructor(candleSizeNames) {
    this.sizeNames = candleSizeNames
  }

  build(waxName, waxUrl, wicks) {
    const wax = new Wax(waxName, waxUrl)

    for (let i = 0; i < this.sizeNames.length; i += 1) {
      wax.addWick(this.sizeNames[i], wicks[i])
    }

    return wax
  }
}

// Candle Wicks
const cd3 = new Wick("CD 3", "/wick/cd-3")
const cd4 = new Wick("CD 4", "/wick/cd-4")
const cd4SixInch = new Wick("CD 4", "/wick/cd-4-6")
const cd6 = new Wick("CD 6", "/wick/cd-6")
const cd8 = new Wick("CD 8", "/wick/cd-8")
const cd10 = new Wick("CD 10", "/wick/cd-10")
const cd12 = new Wick("CD 12", "/wick/cd-12")
const cd14 = new Wick("CD 14", "/wick/cd-14")
const cd18 = new Wick("CD 18", "/wick/cd-18")
const cd20 = new Wick("CD 20", "/wick/cd-20")
const cd22 = new Wick("CD 22", "/wick/cd-22")
const cd24 = new Wick("CD 24", "/wick/cd-24")
const cd26 = new Wick("CD 26", "/wick/cd-26")
const eco75 = new Wick("ECO .75", "/wick/eco-75-tealight")
const eco1 = new Wick("ECO 1", "/wick/eco-1-tealight")
const eco2 = new Wick("ECO 2", "/wick/eco-2")
const eco4 = new Wick("ECO 4", "/wick/eco-4")
const eco6 = new Wick("ECO 6", "/wick/eco-6")
const eco8 = new Wick("ECO 8", "/wick/eco-8")
const eco10 = new Wick("ECO 10", "/wick/eco-10")
const eco12 = new Wick("ECO 12", "/wick/eco-12")
const eco14 = new Wick("ECO 14", "/wick/eco-14")
const eco16 = new Wick("ECO 16", "/wick/eco-16")
const lx8 = new Wick("LX 8", "/wick/lx-8")
const lx12 = new Wick("LX 12", "/wick/lx-12")
const lx14 = new Wick("LX 14", "/wick/lx-14")
const lx16 = new Wick("LX 16", "/wick/lx-16")
const lx18 = new Wick("LX 18", "/wick/lx-18")
const lx20 = new Wick("LX 20", "/wick/lx-20")
const lx22 = new Wick("LX 22", "/wick/lx-22")
const lx24 = new Wick("LX 24", "/wick/lx-24")
const lx26 = new Wick("LX 26", "/wick/lx-26")
const lx28 = new Wick("LX 28", "/wick/lx-28")
const doubleEco2 = new DoubleWicked(eco2)
const doubleEco6 = new DoubleWicked(eco6)
const doubleEco8 = new DoubleWicked(eco8)
const doubleEco10 = new DoubleWicked(eco10)
const tripleLx14 = new TripleWicked(lx14)
const tripleLx16 = new TripleWicked(lx16)
const doubleLx18 = new DoubleWicked(lx18)
const doubleCd6 = new DoubleWicked(cd6)
const doubleCd8 = new DoubleWicked(cd8)
const doubleCd10 = new DoubleWicked(cd10)
const tripleCd4 = new TripleWicked(cd4SixInch)
const tripleCd6 = new TripleWicked(cd6)

// Wax Factory
const containerWaxFactory = new WaxFactory([
  "Tealight",
  'Extra Small (1.75" - 2.19")',
  'Small (2.2" - 2.69")',
  'Medium (2.7" - 2.94")',
  'Large (2.95" - 3.29")',
  'Extra Large (3.3" - 3.79")',
  '2X Large (3.8" - 4.2")',
  '2XL - Multi-Wick (3.8" - 4.5")',
])
const pillarWaxFactory = new WaxFactory([
  "Votive",
  "2 Inch",
  "3 Inch",
  "4 Inch",
])

// Waxes
const blendedWaxes = pillarWaxFactory.build(
  "Blended Waxes® Pillar Soy",
  "/wax/blended-waxes-pillar-soy-wax-bw-921",
  [lx16, lx20, lx26, lx28]
)

const cargillC3 = containerWaxFactory.build(
  "Cargill NatureWax C-3",
  "/wax/cargill-naturewax-c-3-soy-wax",
  [
    eco1,
    new MultipleWickOptions(cd6, eco4),
    new MultipleWickOptions(cd8, eco8),
    new MultipleWickOptions(cd12, eco12),
    new MultipleWickOptions(cd22, eco14),
    new MultipleWickOptions(cd24, eco16),
    new MultipleWickOptions(doubleCd8, doubleEco6),
    tripleCd4,
  ]
)
const cargillC6 = containerWaxFactory.build(
  "Cargill NatureWax C-6 Soy/Coconut Wax",
  "/wax/cargill-naturewax-c-6-soy-coconut-wax",
  [eco1, cd4, cd8, cd14, cd24, doubleCd8, doubleCd10, tripleCd4]
)
const ecosoyaCB = containerWaxFactory.build(
  "Ecosoya CB Advanced",
  "/wax/ecosoya-advanced-soy-wax",
  [
    new MultipleWickOptions(lx8, eco1),
    new MultipleWickOptions(lx14, eco2),
    new MultipleWickOptions(lx16, eco4),
    new MultipleWickOptions(lx20, eco8),
    new MultipleWickOptions(lx22, eco12),
    new MultipleWickOptions(lx26, eco14),
    new MultipleWickOptions(doubleLx18, doubleEco8),
    new MultipleWickOptions(doubleLx18, doubleEco8),
  ]
)
const ecosoyaCB135 = containerWaxFactory.build(
  "Ecosoya CB 135",
  "/wax/ecosoya-cb135-soy-wax-pre-production",
  [
    lx8,
    lx12,
    lx14,
    lx18,
    lx20,
    lx24,
    doubleLx18,
    tripleLx14,
  ]
)
const ecosoyaPB = pillarWaxFactory.build(
  "Ecosoya PB",
  "/wax/ecosoya-pillar-soy-wax",
  [lx14, lx18, lx24, lx26]
)
const gw464 = containerWaxFactory.build(
  "Golden Brands 464 Soy Wax",
  "/wax/golden-brands-464-soy-wax",
  [
    eco75,
    new MultipleWickOptions(cd4, eco4),
    new MultipleWickOptions(cd8, eco8),
    new MultipleWickOptions(cd12, eco10),
    new MultipleWickOptions(cd18, eco14),
    new MultipleWickOptions(cd22, eco16),
    new MultipleWickOptions(cd26, doubleEco10),
    new MultipleWickOptions(tripleCd6, doubleEco10),
  ]
)
const gw444 = containerWaxFactory.build(
  "Golden Brands 444 Soy Wax",
  "/wax/golden-brands-444-soy-wax",
  [
    eco75,
    new MultipleWickOptions(cd4, eco4),
    new MultipleWickOptions(cd10, eco10),
    new MultipleWickOptions(cd14, eco12),
    new MultipleWickOptions(cd20, eco14),
    new MultipleWickOptions(cd24, eco16),
    new MultipleWickOptions(cd26, doubleEco10),
    new MultipleWickOptions(tripleCd6, doubleEco10),
  ]
)
const gw415 = containerWaxFactory.build(
  "Golden Brands 415 Soy Wax",
  "/wax/golden-brands-415-soy-wax",
  [
    eco75,
    new MultipleWickOptions(cd4, eco4),
    new MultipleWickOptions(cd10, eco10),
    new MultipleWickOptions(cd14, eco12),
    new MultipleWickOptions(cd20, eco14),
    new MultipleWickOptions(cd24, eco16),
    new MultipleWickOptions(cd26, doubleEco10),
    new MultipleWickOptions(tripleCd6, doubleEco10),
  ]
)
const igi1239 = pillarWaxFactory.build(
  "IGI 1239 Paraffin Wax",
  "/wax/igi-1239",
  [lx12, lx16, lx20, lx24]
)
const igi4625 = pillarWaxFactory.build(
  "IGI 4625 Pillar Blend Wax",
  "/wax/igi-4625",
  [lx12, lx14, lx18, lx24]
)
const igi4627 = containerWaxFactory.build(
  "IGI 4627 Comfort Blend Wax",
  "/wax/igi-4627",
  [
    lx8,
    lx14,
    lx16,
    lx18,
    lx20,
    lx24,
    lx26,
    tripleLx16,
  ]
)
const igi4630 = containerWaxFactory.build(
  "IGI 4630 Harmony Blend Wax",
  "/wax/igi-4630",
  [
    lx8,
    lx12,
    lx14,
    lx18,
    lx22,
    lx24,
    lx26,
    tripleLx14,
  ]
)
const igi4633 = containerWaxFactory.build(
  "IGI 4633 (J223) Wax",
  "/wax/igi-4633-j223",
  [lx8, lx14, lx16, lx18, lx22, lx24, lx26, tripleLx16]
)
const igi6006 = containerWaxFactory.build(
  "IGI 6006 Paraffin/Soy Blend Wax",
  "/wax/igi-6006",
  [eco75, eco1, eco2, eco4, eco8, eco10, doubleEco2, tripleCd4]
)
const igi6028 = pillarWaxFactory.build(
  "IGI 6028 Parasoy Pillar Blend",
  "/wax/igi-6028-paraffin-soy-pillar-blend-wax",
  [lx14, lx16, lx24, lx28]
)
const igi6046 = containerWaxFactory.build(
  "IGI 6046 Coconut/Paraffin Blend Wax",
  "/wax/igi-6046-coconut-paraffin-blend-candle-wax",
  [eco75, cd3, cd4, cd8, cd12, cd18, doubleCd6, tripleCd4]
)

// Types of Container waxes
const containerWaxes = [
  new WaxGroup("Soy Container Wax", [
    gw464,
    gw444,
    gw415,
    ecosoyaCB,
    ecosoyaCB135,
    cargillC3,
    cargillC6,
  ]),
  new WaxGroup("Paraffin Container Wax", [igi4630, igi4627, igi4633]),
  new WaxGroup("Paraffin/Natural Container Wax", [igi6006, igi6046]),
]

const pillarWaxes = [
  new WaxGroup("Soy Pillar Wax", [blendedWaxes, ecosoyaPB]),
  new WaxGroup("Paraffin Pillar Wax", [igi4625, igi1239]),
  new WaxGroup("Paraffin-Natural Blends Pillar Wax", [igi6028])
]

export { containerWaxes, pillarWaxes }
